import { render, staticRenderFns } from "./PostAttachments.vue?vue&type=template&id=f23e84e0&scoped=true"
import script from "./PostAttachments.vue?vue&type=script&lang=js"
export * from "./PostAttachments.vue?vue&type=script&lang=js"
import style0 from "./PostAttachments.vue?vue&type=style&index=0&id=f23e84e0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f23e84e0",
  null
  
)

export default component.exports